/*
Generic hook that can be used to find a master-account id based on a set of parameters.
This is useful for things like email filing where you need to determine what master account based off the
email address of the sender.
*/
import { useAuth } from "react-oidc-context";
import { toNString } from "../helpers/guids";
import { useLookupMasterAccountQuery } from "../services/clientsearch";
import { type MasterAccountSearchResult } from "../types/MasterAccountSearchResult";

// TODO: you could add more here, etc..
export type useMasterAccountLookupProps = {
    accountId?: string | null | undefined
    accountName?: string | null | undefined
    accountReference?: string | null | undefined
    emailAddress?: string | null | undefined
}

export type useMasterAccountLookupOpts = {
    data: MasterAccountSearchResult | null
    error: Error | string | null
    isBusy: boolean
    isFetching: boolean
    isLoading: boolean
    lookedUpById: string
};

export const useMasterAccountLookup = (opts: useMasterAccountLookupProps) : useMasterAccountLookupOpts => {
    const { user } = useAuth();
    const { data, error, isLoading, isFetching } = useLookupMasterAccountQuery(opts);
    const isBusy = isLoading || isFetching;

    return {
        data,
        error,
        isBusy,
        isLoading,
        isFetching,
        lookedUpById: toNString(user?.profile.sub)
    };
};